import {
  FETCH_DATA_CREATE_ENTITY_REQUEST,
  FETCH_DATA_CREATE_ENTITY_SUCCESS,
  FETCH_DATA_CREATE_ENTITY_FAILURE,
} from "../../actions/entities/create-entities-actions";

const initialState = {
  entityCreated: null,
  isLoading: false,
  error: null,
};

const CreateEntityReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case FETCH_DATA_CREATE_ENTITY_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case FETCH_DATA_CREATE_ENTITY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        entityCreated: { ...action.payload },
      };
    case FETCH_DATA_CREATE_ENTITY_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default CreateEntityReducer;
